import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, ChevronRight, Activity, ShieldAlert } from 'lucide-react';
import { getCategories } from '../lib/categories';
import { stripHtml } from '../lib/richText';

export default function DiseaseCard({ disease, index = 0 }) {
  return (
    <Link
      to={`/diseases/${disease.slug}`}
      className="dp-card p-4 sm:p-5 block dp-fade-in min-w-0 transition hover:border-[#B40026]/40 hover:shadow-md"
      style={{ animationDelay: `${index * 30}ms` }}
    >
      {/* Category & Status Chips */}
      <div className="flex items-center gap-1.5 mb-2.5 flex-wrap">
        {getCategories(disease).map((c) => (
          <span key={c} className="dp-chip dp-chip-red text-[11px] font-semibold">
            {c}
          </span>
        ))}
        {disease.chronicity && (
          <span className="dp-chip text-[11px]">
            {disease.chronicity}
          </span>
        )}
        {disease.emergency && (
          <span className="dp-chip text-[11px] font-bold inline-flex items-center gap-1" style={{ backgroundColor: '#B40026', color: '#fff' }}>
            <AlertTriangle className="w-3 h-3" /> Emergency
          </span>
        )}
      </div>

      {/* Main Title & ICD-10 */}
      <div className="flex items-start justify-between gap-2 min-w-0">
        <div className="min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="text-lg font-bold leading-tight text-[#1E1E24] dark:text-white">
              {disease.name}
            </h3>
            {disease.icd10 && (
              <span className="text-[10px] font-mono font-semibold px-1.5 py-0.5 rounded bg-black/5 dark:bg-white/10 text-[#707078] dark:text-[#A0A0A8]">
                {disease.icd10}
              </span>
            )}
          </div>
          <p className="text-sm text-[#707078] mt-1.5 line-clamp-2 leading-relaxed">
            {stripHtml(disease.short || disease.simple || disease.medical)}
          </p>
        </div>
        <ChevronRight className="w-5 h-5 text-[#B40026] flex-shrink-0 mt-1" />
      </div>

      {/* CBHI Epidemiology Burden Snippet */}
      {disease.cbhiStats && (
        <div className="mt-3 p-2 rounded-xl bg-amber-500/[0.06] border border-amber-500/20 text-[11px] text-amber-900 dark:text-amber-300">
          <span className="font-bold">National Burden: </span>
          <span className="line-clamp-1">{disease.cbhiStats.annualCasesIndia || disease.cbhiStats.burdenIndia}</span>
        </div>
      )}

      {/* Card Footer */}
      <div className="mt-4 pt-3 border-t border-black/5 dark:border-white/5 flex items-center justify-between gap-3 text-xs text-[#707078]">
        <span className="min-w-0">
          Level: <span className="font-semibold text-[#282832] dark:text-white">{disease.difficulty || 'MBBS'}</span>
        </span>
        <span className="text-[#B40026] font-semibold flex items-center gap-1 group-hover:translate-x-0.5 transition-transform">
          Study Monograph →
        </span>
      </div>
    </Link>
  );
}
